import { inject, Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import EventParams = firebase.analytics.EventParams;
import { WindowRefService } from '../modules/share/services/window-ref.service';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { logEvent } from '@angular/fire/analytics';

export interface AnalyticsEvent {
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
  eventValue: number;
}

export interface AnalyticsScreenViewEvent {
  eventName: 'screen_view';
  eventParams?: {
    firebase_screen: EventParams['firebase_screen'];
    firebase_screen_class: EventParams['firebase_screen_class'];
    [key: string]: any;
  };
  options?: firebase.analytics.AnalyticsCallOptions;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  windowRef = inject(WindowRefService);

  private analyticsPromise = isSupported().then((supported) => {
    if (!supported) return null;
    return getAnalytics();
  });

  get ga(): (send: string, event1: string, event?: AnalyticsEvent | string) => void {
    return this.windowRef.nativeWindow['ga'];
  }

  sendPage(page: string): void {
    if (this.ga) {
      this.ga('wssAaaTracker.set', 'page', page);
      this.ga('wssAaaTracker.send', 'pageview');
    }
  }

  sendEvent(event: AnalyticsEvent): void {
    if (this.ga) {
      this.ga('wssAaaTracker.send', 'event', event);
    }
  }

  async sendFirebaseScreenViewEvent(analyticsEvent: AnalyticsScreenViewEvent) {
    const analytics = await this.analyticsPromise;
    if (!analytics) return;

    logEvent(analytics, analyticsEvent.eventName, analyticsEvent.eventParams);
  }
}
